import { render, staticRenderFns } from "./BlackInputPeopleNum.vue?vue&type=template&id=927e596c&scoped=true"
import script from "./BlackInputPeopleNum.vue?vue&type=script&lang=js"
export * from "./BlackInputPeopleNum.vue?vue&type=script&lang=js"
import style0 from "./BlackInputPeopleNum.vue?vue&type=style&index=0&id=927e596c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e596c",
  null
  
)

export default component.exports